/**
 * Dunkles Farbschema – ordnet primitive Farb-Tokens semantischen Palette-Slots zu.
 * Wird von darkTheme.ts verwendet, um das MUI-Theme zu erstellen.
 */

import {PaletteOptions} from '@mui/material/styles';

import {
  yellow,
  slate,
  neutral,
  surface,
  status,
  overlay,
  accent,
} from './customColors';

export const darkPalette: PaletteOptions = {
  // ─── MUI Standard Palette ───────────────────────────────────────────────────

  common: {
    black: neutral.black,
  },
  mode: 'dark',
  primary: {
    main: yellow.main,
    light: yellow.light,
    dark: yellow.dark,
  },
  secondary: {
    main: slate.main,
    light: slate.light,
    dark: slate.dark,
  },
  warning: {
    main: status.warning.main,
    light: status.warning.light,
    dark: status.warning.dark,
  },
  error: {
    main: status.error.main,
    light: status.error.light,
    dark: status.error.dark,
  },
  success: {
    main: status.success.main,
    light: status.success.light,
    dark: status.success.dark,
    contrastText: neutral.white,
  },
  background: {
    default: surface.dark,
    paper: surface.darkElevated,
  },

  // ─── Custom Palette Extensions ──────────────────────────────────────────────

  misc: {
    main: neutral.greyAlpha59,
    light: neutral.greyAlpha33,
    dark: neutral.grey900,
    contrastText: neutral.white,
  },
  pending: {
    main: status.info.main,
    light: status.info.light,
    dark: status.info.dark,
    contrastText: neutral.white,
  },
  loginPage: {
    background: overlay.loginGradient,
    formBoxBackground: overlay.black50,
    topBannerBackground: surface.topBanner,
  },
  app: {
    boxBackground: surface.dark,
    boxBorder: surface.dark,
    basketBadgeBackground: slate.light,
  },
  basketPopover: {
    customPopover: surface.darkElevated,
    itemCardBackground: surface.darkElevated,
    deleteBasketText: neutral.white,
    deleteBasketTextHover: neutral.white,
  },
  itemCard: {
    cardBackground: surface.darkElevated,
    imageBoxBackground: surface.darkElevated,
  },
  table: {
    background: surface.dark,
  },
  tableRow: {
    background: surface.dark,
  },
  itemView: {
    paper: overlay.black20,
  },
  structureMainView: {
    itemBackground: surface.darkElevated,
    paper: surface.dark,
  },
  structureTree: {
    customDrawerBackground: surface.dark,
  },
  structureTreeItem: {
    secondaryLabelColor: overlay.white70,
  },
  metadataComponent: {
    paper: surface.dark,
    tabDisabledText: neutral.greyAlpha33,
  },
  fileNameInfo: {
    navButtonColor: accent.hoverYellow,
  },
  fileUploadDialog: {
    background: surface.darkElevated,
    paper: surface.darkElevated,
    tableBackground: surface.darkElevated,
    tableHeaderBackground: surface.darkElevated,
  },
  appBar: {
    background: surface.dark,
    typography: neutral.white,
  },
  footer: {
    paper: overlay.black50,
  },
  sideBar: {
    iconColorActive: neutral.white,
    iconColorInactive: neutral.white,
    typography: neutral.white,
    paper: surface.dark,
    menuPaper: surface.dark,
  },
  derivatePanelGroup: {
    cardBackground: surface.darkElevated,
  },
  userManagement: {
    fontColorSelected: neutral.black,
  },
  itemStatus: {
    background: surface.darkElevated,
    hoverBackground: surface.dark,
    menuItemBackground: surface.darkElevated,
  },
  customButton: {
    blackColor: neutral.white,
  },
  hero: {
    gradient: `linear-gradient(transparent 50%, ${surface.dark})`,
    searchBar: {
      background: surface.dark,
      hover: neutral.grey800,
    },
  },
  imageEditor: {
    preview: {
      backgroundColor: surface.darkElevated,
      backgroundImage:
        `linear-gradient(45deg, ${surface.dark} 25%, transparent 25%),` +
        `linear-gradient(-45deg, ${surface.dark} 25%, transparent 25%),` +
        `linear-gradient(45deg, transparent 75%, ${surface.dark} 75%),` +
        `linear-gradient(-45deg, transparent 75%, ${surface.dark} 75%)`,
      overlayColor: surface.darkAlpha50,
    },
  },
};
